import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { AppStyles } from '../../styles/AppTheme';
import { Tooltip } from '@material-ui/core';
import { SubtaskImagePreviewDialog } from '../../components/SubtaskImagePreviewDialog';
import { SubEntityList } from '../../common/components/SubEntity/SubEntityList';
import { SubEntityCard } from '../../common/components/SubEntity/SubEntityCard';
import { DynamicFormDialog } from '../../common/components/DynamicFormDialog';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { TaskConsolidateViewDialog } from '../../components/TaskConsolidateViewDialog';
import { taskExtraFieldsToShow } from '../../data/data';

const queryString = require('query-string');
export class Task extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'SubTasks'
    this.pageTitle = Helper.getString('subTask')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.taskId = this.props.match.params.id
    this.query = queryString.parse(props.location.search);
    this.toFetch = [
      { method: 'GET', paths: ['tasks', this.taskId], queryParams: { pb: 'fieldDefSubtask, fieldDef' } },
      { method: 'GET', paths: ['users'], queryParams: { orgId: this.orgId, pb: 'fieldDef' } }
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Type: (current) => this.getiTypeLabelByKey(current.iType),
      Result: (current) => {
        return this.getValues(current)
      },
      Mandatory: (current) => current.mandatory,
      'Field Order': (current) => current.order
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.allowAccessToRoles = ['SUPERUSER']
    this.noAdd = true
    if (!UiHelper.isUserHasRoles(this.allowAccessToRoles)) {
      this.noAddSubEntity = true
    }
  }

  setBreadCrumb() {
    if (this.query && this.query.venueCode) {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: Helper.getString('venues'), to: this.baseRoute() + '/screens' },
        { title: Helper.getString('tasks') + ':' + this.query.venueCode, to: this.baseRoute() + '/screens/' + this.query.venueCode + '/tasks' },
        { title: this.pageTitle },
      ]
    } else {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: Helper.getString('tasks'), to: this.baseRoute() + '/tasks' },
        { title: this.pageTitle },
      ]
    }
  }

  getiTypeLabelByKey(typeKey) {
    const options = this.formDefinition.steps[0].fields.find(i => i.key === 'iType').options
    const item = options.find(obj => obj.key === typeKey)
    return item ? item.label : typeKey
  }

  getValues(current) {
    if (current && current.iType === 'IMAGES') {
      if (!current.values || (Array.isArray(current.values) && current.values.length < 1)) return;
      return `${current && current.values ? current.values.length : 0} Image(s)`;
    }
    const values = current && current.values ? current.values : [];
    if (current && current.iType === 'COMMENT') {
      return (
        <div className={css(Styles.allValues)}>
          {values.length > 0 && values.map((item, index) => (
            <span key={index} className={css(Styles.eachValue)}>
              {item}
            </span>
          ))}
        </div>
      )
    }
    // Activation
    if (current && current.iType === 'ACTIVATION') {
      return (
        <div className={css(Styles.allValues)}>
          {values.length > 0 && values.map((item, index) => (
            <span key={index} className={css(Styles.eachValue)}>
              Activation Done: {item}
            </span>
          ))}
        </div>
      )
    }
    return (
      <div className={css(Styles.allValues)}>
        <span className={css(Styles.eachValue)}>
          {values.join(', ')}
        </span>
      </div>
    )
  }

  convertObjectToArray(data) {
    return Object.values(data);
  }

  onFetchSuccess(results) {
    if (results[0] && results[0].title) {
      this.pageTitle = results[0].title
      this.setBreadCrumb()
    }
    this.formDefinition = results[0].fieldDefSubtask // SubTasks

    this.formDefinitionTask = results[0].fieldDef // Tasks
    this.formDefinitionTask.steps[0].fields.push(...taskExtraFieldsToShow)
    const installerUsers = this.getInstallers(results[1].items)
    UiHelper.populateOptions(this.formDefinitionTask, { items: installerUsers }, 'assigneeId')

    // Add Create, Completed & Rejected & Reason
    const displayFields = [
      {
        key: 'createdTs',
        label: 'Created on',
      },
    ]

    this.taskItems = results[0] || {} // Tasks
    const subTasks = this.convertObjectToArray(results[0].subtasks) // Get Installer to options list

    // Subtask label
    const subtaskLists = results[0].fieldDefSubtask.steps[0].fields.find(x => x.key === 'iType')
    if (subtaskLists && subtaskLists.options) {
      this.subtaskLists = subtaskLists.options
    }

    this.setState({
      items: subTasks,
      modalOpenTaskEdit: false,
      displaySubtaskDialog: false
    })

    const { imgSubTasks, nonImgSubTasks } = AppHelper.processSubtasks({ task: this.taskItems })
    if (nonImgSubTasks.length > 0 || imgSubTasks.length > 0) {
      this.headerActions = [
        {
          icon: 'visibility',
          label: 'Preview',
          onClick: () => this.displaySubtaskModal(this.taskItems)
        }
      ]
    }
  }

  // Populate user to options
  getInstallers(usersData) {
    // Check if user data is empty or not an array
    if (!usersData || !Array.isArray(usersData) || usersData.length === 0) {
      return [];
    }
    // Filter for users with the "INSTALLER" role and map to desired format
    return usersData
      .filter(user => user.roles && user.roles.includes('INSTALLER'))
      .map(user => ({
        id: user.userId,
        title: `${user.email}`,
        text: `${user.email}`,
        key: user.userId,
      }));
  }

  renderAboveTable() {
    return (
      <div className={css(Styles.taskDetailsComponents)}>
        {/* Edit Task */}
        <DynamicFormDialog
          apiMethod={'PUT'}
          apiEndPoint={ApiHelper.makeUrlPath(['tasks', this.taskId])}
          apiData={this.apiData}
          formDefinition={this.formDefinitionTask}
          isOpen={this.state.modalOpenTaskEdit}
          onClosed={() => this.setState({ modalOpenTaskEdit: false })}
          onCompleteAction={() => {
            this.setState({ modalOpenTaskEdit: false, items: [] })
            this.fetchItems()
          }} />
        {/* Subtask Image Preview  */}
        <SubtaskImagePreviewDialog
          isOpen={this.state.displayImageDialog || false}
          title={this.state.modalTitle}
          onClosed={() => { this.setState({ displayImageDialog: false }) }}
          ads={this.state.images || []}
        ></SubtaskImagePreviewDialog>
        {/* Tak preview */}
        <TaskConsolidateViewDialog
          isOpen={this.state.displaySubtaskDialog || false}
          title={this.state.modalTitle || ''}
          onClosed={() => { this.setState({ displaySubtaskDialog: false }) }}
          task={this.state.task || []}
          subtaskLabelMap={this.subtaskLists}
        ></TaskConsolidateViewDialog>

        {/* Component */}
        <div className={css(Styles.taskInfoBlock)}>
          <SubEntityCard
            renderFieldsRowwise={true}
            title={'Info'}
            formDefinition={this.formDefinitionTask || {}}
            item={this.taskItems || {}}
            openModalForEdit={(current) => {
              this.openModalForEditTask({ current, title: this.pageTitle })
            }}
            valueStyle={{
              whiteSpace: 'normal !important'
            }}
          />
        </div>
        <div className={css(Styles.subTaskInfoBlock)}>
          <SubEntityList
            title={Helper.getString('subTask')}
            buttonTitle={Helper.getString('addSubTask')}
            tableHeadersMap={this.tableHeadersMap}
            items={this.state.items}
            noAdd={this.noAddSubEntity}
            openModalForAdd={(current) => this.openModalForAdd({ current, entityAttrName: 'subtasks', entityAction: 'add' })}
            subEntityActions={this.subEntityActions.bind(this)}
            buttonStyle={{
              minWidth: 160
            }}
            buttonTextStyle={{
              color: '#fff'
            }}
            tableContainer={{
              padding: 0
            }}
          />
        </div>
      </div>
    )
  }

  openModalForEditTask({ current }) {
    if (current) {
      // Remove Fields while editing
      const keysToRemove = taskExtraFieldsToShow.map(field => field.key);
      this.formDefinitionTask.steps[0].fields = this.formDefinitionTask.steps[0].fields.filter(
        field => !keysToRemove.includes(field.key)
      )

      this.formDefinitionTask.formType = 'edit'
      this.formDefinitionTask.steps[0].fields.find(i => i.key === 'deviceCode').disabled = true
      Helper.populateFormDefinitionValues(this.formDefinitionTask, current)
    }
    this.setState({
      modalOpenTaskEdit: true
    });
  }

  subEntityActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, this.adPlayerButton(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonDelete(this, current), this.allowAccessToRoles)
    return actions
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        entityAttrName: 'subtasks',
        entityAction: 'edit',
        id: current.id
      },
      apiEndPoint: ApiHelper.makeUrlPath(['tasks', this.taskId]),
    });
  }

  onDelete(current) {
    console.log(current)
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        entityAttrName: 'subtasks',
        entityAction: 'del',
        id: current.id
      },
      apiEndPoint: ApiHelper.makeUrlPath(['tasks', this.taskId]),
    });
  }

  openModalForAdd({ current, entityAttrName, entityAction }) {
    this.formDefinition.formType = 'add'
    Helper.deleteFormDefinitionValues(this.formDefinition)
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        entityAttrName,
        entityAction,
      },
      apiEndPoint: ApiHelper.makeUrlPath(['tasks', this.taskId]),
      modalOpen: true
    });
  }

  openModalForEditSubtask({ current, entityAttrName, entityAction }) {
    if (current) {
      this.formDefinition.formType = 'edit'
      Helper.populateFormDefinitionValues(this.formDefinition, current)
    }
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        entityAttrName,
        entityAction,
        id: current.id
      },
      apiEndPoint: ApiHelper.makeUrlPath(['tasks', this.taskId]),
      modalOpen: true
    });
  }

  displayImages(current) {
    this.setState({
      displayImageDialog: true,
      modalTitle: this.getiTypeLabelByKey(current.iType),
      images: current.values,
    })
  }

  adPlayerButton(e, current) {
    if (current && current.iType !== 'IMAGES') return;
    if (!current.values || (Array.isArray(current.values) && current.values.length < 1)) return;
    return (
      <Tooltip title={Helper.getString('displayImages')} placement='top-start' key={'adsPlayButton'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.displayImages(current)}>play_circle</i>
        </span>
      </Tooltip>
    )
  }

  displaySubtaskModal(current) {
    if (!current.subtasks || (current.subtasks && Object.keys(current.subtasks).length < 1)) return ''
    console.log(current)
    this.setState({
      displaySubtaskDialog: true,
      modalTitle: current.title || '',
      task: current
    })
  }


}
const Styles = StyleSheet.create({
  allValues: {
    maxWidth: 400
  },
  eachValue: {
    maxWidth: '100%',
    lineBreak: 'anywhere',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 12
  },
  taskDetailsComponents: {
    flex: 1
  },
  taskInfoBlock: {
    marginBottom: 20
  },
  subTaskInfoBlock: {
    marginBottom: 20
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/Task.js